/* Copyright (c) 2023, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { isBoolean, isNil } from 'lodash';
import { LoggingService, Logger } from '../logging/logging.service';
import { ImageFileFormat, ImageProperties } from './image-format';

@Injectable({
    providedIn: 'root'
})
export class ImageFormatService {
    private logger: Logger;
    private readonly defaultImageProperties: ImageProperties = { f: ImageFileFormat.webp };

    constructor(loggingService: LoggingService) {
        this.logger = loggingService.getLogger('ImageFormatService');
    }

    formatImageServiceUrl(imageUrl: string, properties: ImageProperties = {}): string {
        const mergedProperties = {
            ...this.defaultImageProperties,
            ...properties
        };
        const mergedPropertiesKeyList = Object.keys(mergedProperties);
        for (const key of mergedPropertiesKeyList) {
            const value =
                mergedProperties[key] || isBoolean(mergedProperties[key]) ? '' + mergedProperties[key] : undefined;
            if (value && value.length > 0 && !isNil(imageUrl)) {
                imageUrl += ';' + key + '=' + mergedProperties[key];
            }
        }
        return imageUrl;
    }
}
